module.exports = __webpack_public_path__ + "img/12_99.75e672fd.png";